import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class InformationProvider {
    private currentModuleName = '';

    public onCurrentModuleChange: BehaviorSubject<string> = new BehaviorSubject<string>('');
    public onCurrentUrlChange: BehaviorSubject<string> = new BehaviorSubject<string>('');
    public onPageNotFound: EventEmitter<boolean> = new EventEmitter<boolean>();

    public pageNotFound() {
        this.onPageNotFound.emit(true);
    }

    public changeCurrentModuleName(name: string) {
        name = name || '';
        name = name.trim().toLowerCase();

        if (name !== this.currentModuleName) {
            this.currentModuleName = name;
            this.onCurrentModuleChange.next(this.currentModuleName);
        }
    }

    public changeCurrentUrl(url) {
        this.onCurrentUrlChange.next(url);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/providers/information.provider.ts